import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/auth/auth.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { UserService } from 'app/auth/user.service';

@Component({
  selector: 'app-supplier-menu',
  templateUrl: './supplier-menu.component.html',
  styleUrls: ['./supplier-menu.component.scss']
})
export class SupplierMenuComponent implements OnInit {

  @Input() supplierId: string = null;
  @Input() supplierName: string = null;
  @Input() menuItem: number = null;

  constructor(
    public router: Router,
    public auth: AuthService,
    public configuration: ConfigurationService,
    public userService: UserService
  ) {
  }

  ngOnInit() {
    this.userService.getUserProfile().then(resp => {


    })
  }

  public onClick() {
  }

  public onClickPublicProfile() {
    this.router.navigate(['/smart-cities-suppliers', this.supplierId]);
  }

  public onClickOpportunities() {
    if (this.userCanAccessOpportunitiesMap()) {
      this.router.navigate(['/supplier-opportunities', this.supplierId]);
    }
  }

  public onClickSolutions() {
    if (this.canAccess()) {
      this.router.navigate(['/supplier-solutions', this.supplierId]);
    }
  }

  public onClickEditSupplier() {
    if (this.canAccess()) {
      this.router.navigate(['/edit/supplier', this.supplierId]);
    }
  }

  public onClickUsers() {
    if (this.canAccess()) {
      this.router.navigate(['/supplier-users', this.supplierId]);
    }
  }

  public canAccess(): boolean {
    return this.userService.canEditCompany(this.supplierId);
  }

  public getRoles(type) {

  }

  public userCanAccessOpportunitiesMap(): boolean {
    return this.userService.userCanAccessOpportunitiesMap(this.supplierId);
  }

}
